<template>
  <div class="container">
    <div class="row">

      <div class="col-12 offset-lg-2 col-lg-8">
        <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
          <b>更新メッセージ</b>
        </div>


        <page-form :family_relations="family_relations" :child_infos="child_infos" @tryForm="tryForm" @remove="remove"></page-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Master from 'processor/Master'
  import ChildInfo from 'processor/ChildInfo'
  import ChildDeleteConfirmModal from 'components/modal/ChildDeleteConfirmModal.vue'

  import PageForm from 'page/partials/MyPage/ChildInfo/PageForm.vue'

  /** @name page_subPages_MyPage_ChildInfo */
  export default {
    name:"",
    components: {
      PageForm,
      ChildDeleteConfirmModal,
    },
    data () {
      return {
        apiErrorI18nKey:null,
        family_relations:[],
        child_infos:[]
      }
    },
    mounted(){
      let input = {
          lang:store.get("i18n")
      }
      Master.getFamilyRelation(input)
        .then((res) => {
          //dd("test",res);
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.family_relations = res.data.family_relations
        })
      ChildInfo.get(input)
        .then((res) => {
          //dd("test",res);
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.child_infos = res.data.child_info
        })
    },
    methods:{
      remove(){
          let inputs = {}
          app.make("axios").delete(`v1/account/child-info/${this.$route.params.child_info_id}`,inputs)
            .then(({data}) =>{
              let input = {}
              ChildInfo.get(input)
                .then((res) => {
                  if (res.status === "ng") {
                    this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
                    return
                  }
                  this.child_infos = res.data.child_info

                  this.$router.push({ name: 'mypage::child_info', params: {} })
                  $("#ChildDeleteConfirmModal").modal("hide")

                })
            })
            .catch(error => {
            })
      },
      tryForm(input){
        input["id"] = this.$route.params.child_info_id || null

        //dd("abc",input);
        ChildInfo.save(input)
          .then((res)=>{

            let child_info = res.data.child_info

            this.apiErrorI18nKey = "更新メッセージ"

            ChildInfo.get(input)
              .then((res) => {
                if (res.status === "ng") {
                  this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
                  return
                }
                this.child_infos = res.data.child_info

                if(!this.$route.params.child_info_id){
                  this.$router.push({ name: 'mypage::child_info::detail', params: {child_info_id:child_info.id} })
                }
              })

          })
        //location.reload()

      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ChildInfo.vue?7dec5ee4